<template>

  <ContentsProductHighPerformancePageTitle title="PSU (Polysulfone)" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/psu01.jpg"
            credit="Photo credit:https://products.cpcworldwide.com"
            :contents="[
              `Polysulfone is another type of high heat amorphous material (Tg 190c, HDT 174c). It has practical
              strength, good hydrolytic stability, good chemical resistance to acid, base, corrosive agent, but not to
              solvent. All of polysulfone materials are BPA free`,
            ]"
            :is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/psu02.jpg"
            :contents="[
              `Food contact, drinking water and healthcare application that need to withstand high temperature,
              resistance to chemical exposure and require transparency such as baby bottle, airline food service, coffee
              machine parts`,
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'BASF',
              width: '33.333%',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo01.jpg',
              }
            },
            {
              name: 'Solvay',
              width: '34.089%',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo02.jpg',
              }
            },
            {
              name: 'RTP',
              width: '32.242%',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo03.jpg',
              }
            }
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'psu - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>

.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}
.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>